const Button = ({
  children,
  onClick,
  variant = 'primary',
  fullWidth = false,
  disabled = false,
  style = {}
}) => {
  const base = {
    width: fullWidth ? '100%' : 'auto',
    border: 'none',
    borderRadius: 14,
    padding: '14px 20px',
    fontSize: 15,
    fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    transition: 'all 0.2s',
    fontFamily: 'DM Sans, sans-serif',
    ...style
  }

  const variants = {
    primary: {
      background: 'var(--green)',
      color: 'white',
    },
    secondary: {
      background: 'transparent',
      color: 'var(--green)',
      border: '1.5px solid var(--green-mid)',
    },
    danger: {
      background: 'transparent',
      color: 'var(--red)',
      border: '1.5px solid #fecaca',
    }
  }

  return (
    <button
      onClick={disabled ? undefined : onClick}
      style={{ ...base, ...variants[variant] }}>
      {children}
    </button>
  )
}

export default Button